/**
 * AD inbound directory detail — Users tab URL search-param schema.
 *
 * Per CLAUDE.md "URL is the source of truth for list/filter state":
 * no React useState mirroring these. Prefixed `users_*` because the
 * detail route (`$directoryId.tsx`) owns the Users AND Groups tabs'
 * pagination/filter state in one combined search schema — without the
 * prefix the two tabs' `offset`/`sync_status`/`q` params would collide
 * in the URL even though only one tab renders at a time.
 *
 * The query layer (`fetchAdDirectoryUsers` / `AdDirectoryLinksFilter`
 * in schemas.ts) uses the unprefixed shape; the page maps
 * `search.users_*` onto that filter at the call site.
 */

import { z } from "zod";
import { adDirectoryLinkSyncStatusSchema } from "./schemas";

export const adInboundUsersSearchSchema = z.object({
  users_offset: z.coerce.number().int().nonnegative().optional(),
  users_sync_status: adDirectoryLinkSyncStatusSchema.optional(),
  users_q: z.string().optional(),
});
export type AdInboundUsersSearch = z.infer<typeof adInboundUsersSearchSchema>;
